module.exports = "<button type=\"button\" class=\"btn btn-default btn-lg\" (click)=\"print()\" [disabled]=\"isDisabled\">\n    <i class=\"fi fi-print\"></i>Print\n</button>"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/buttons/print-btn/print-btn.html
// module id = ./web/modern/components/buttons/print-btn/print-btn.html
// module chunks = 0